import { useCallback, useMemo } from "react"
import { 
    uploadItems as createApi,
    deleteItem as deleteApi,
} from "./api"
import useRegularRequest from "../../../../../../queries/useRegularRequest"

export default function useUploadDocumentQueries(){

    const {
        queryRequest: uploadItems,
        isLoading: isUploadingItems
    } = useRegularRequest({ requestHandler: createApi })

    const {
        queryRequest: deleteItem,
        isLoading: isDeletingItem,
    } = useRegularRequest({ requestHandler: deleteApi })

    const isLoadingHttpRequest = useMemo(() => {
        return isUploadingItems === true ||
        isDeletingItem === true
    }, [
        isUploadingItems,
        isDeletingItem
    ])

    return {
        isLoadingHttpRequest,

        uploadItems, isUploadingItems,
        deleteItem, isDeletingItem,
    }
}